module.exports = __webpack_public_path__ + "static/media/wujinlogo.34d597b1.png";